import { Box, Text } from '@user-portal/wikr-components';
import styled, { css } from 'styled-components';

import { mediaQueries } from 'theme/mediaQueries';
import { color } from 'theme/selectors';

export const Container = styled(Box)`
    display: flex;
    flex-grow: 1;
    justify-content: center;
    max-width: 408px;
    flex-direction: column;
    margin: 0 auto;
`;

export const Title = styled(Text)<{ isMobileDevice: boolean }>`
    ${mediaQueries.tabletLandscape} {
        font-size: 40px;
        line-height: 52px;
        text-align: center;
    }
    ${({ isMobileDevice }) =>
        !isMobileDevice &&
        css`
            margin-bottom: 16px;
        `}
`;

export const TitleHighlight = styled.span`
    background: linear-gradient(to top, #bef5da 40%, transparent 40%);
    box-decoration-break: clone;
`;

export const HighlightEmail = styled.b`
    color: ${color('text-main')};
    word-break: break-word;
`;
